import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { AuthContext } from "../../contexts/AuthContext";
import getValidRoute from "../../utils/routesConfig";
import { navigate } from "gatsby";

const PrivateRoute = ({
  isLoggedIn,
  component: Component,
  isLogin,
  ...props
}) => {
  const { isAuth, goToLogin, userInfo } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuth)
      goToLogin({
        prevPath: props && props.location && props.location.pathname,
      });
    if (props && props.location) {
      const validRoute = getValidRoute(props.location.pathname, userInfo);
      if (validRoute) navigate(validRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isAuth) return <div>Cargando...</div>;

  return <Component {...props} />;
};

PrivateRoute.propTypes = {
  isLoggedIn: PropTypes.bool,
  component: PropTypes.node,
};

export default PrivateRoute;
